var map = {
	"./about.png": 4357,
	"./dict.png": 5860,
	"./domcument.png": 1070,
	"./index.png": 5854,
	"./menu.png": 2561,
	"./plan.png": 8793,
	"./record.png": 8699,
	"./role.png": 1316,
	"./task.png": 7883,
	"./user.png": 6937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4059;